import Splide from "@splidejs/splide";

export default function () {
  // product slider
  let product: Splide | null = null;
  let productThumbs: Splide | null = null;
  if (document.querySelector("#product-main > div")) {
    product = new Splide("#product-main > div", {
      type: "fade",
      // heightRatio: 0.5,
      pagination: false,
      arrows: false,
      // cover: true,
    });
  }
  if (document.querySelector("#product-thumbnails > div")) {
    productThumbs = new Splide("#product-thumbnails > div", {
      rewind: false,
      // fixedWidth: 140,
      // fixedHeight: 140,
      isNavigation: true,
      gap: 16,
      focus: "center",
      pagination: false,
      cover: false,
      perPage: 5,
      arrows: false,
      dragMinThreshold: {
        mouse: 4,
        touch: 10,
      },
    });
  }

  if (product && productThumbs) {
    product.sync(productThumbs).mount();
    productThumbs.mount();
  }
}
